





import Vue from 'vue'

export default Vue.extend({
  methods: {
    onClick(): void {
      this.$emit('close-modal')
    }
  },
})
